import { faker } from '@faker-js/faker'
import { subDays, format } from 'date-fns'
import { Factory, trait } from 'miragejs'
import { createOrUpdateTeacherSubscriptionUtilisation } from 'teacher-ui-client/mirage/helpers/subscriptions'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

function createTrialSubscription(teacher, server, subscriptionType, dates = {}) {
  server.create('teacher-subscription', {
    teacher,
    subscriptionType,
    ...dates,
  })
  createOrUpdateTeacherSubscriptionUtilisation(server, teacher.id, { subscriptionType })
}

export default Factory.extend({
  firstName() {
    return faker.person.firstName()
  },
  lastName() {
    return faker.person.lastName()
  },
  login() {
    return faker.internet.username()
  },
  email() {
    return faker.internet.exampleEmail()
  },
  emailConfirmedAt() {
    return subDays(new Date(), 200)
  },

  locale() {
    return 'en'
  },

  mathsTrialSubscription: trait({
    afterCreate(teacher, server) {
      createTrialSubscription(teacher, server, SubscriptionType.Maths)
    },
  }),

  readingTrialSubscription: trait({
    afterCreate(teacher, server) {
      createTrialSubscription(teacher, server, SubscriptionType.Reading)
    },
  }),

  mathsTrialSubscriptionExpired: trait({
    afterCreate(teacher, server) {
      const now = new Date()
      const endDate = format(subDays(now, 10), 'yyyy-MM-dd')
      const startDate = format(subDays(now, 20), 'yyyy-MM-dd')
      createTrialSubscription(teacher, server, SubscriptionType.Maths, { startDate, endDate })
    },
  }),

  readingTrialSubscriptionExpired: trait({
    afterCreate(teacher, server) {
      const now = new Date()
      const endDate = format(subDays(now, 10), 'yyyy-MM-dd')
      const startDate = format(subDays(now, 20), 'yyyy-MM-dd')
      createTrialSubscription(teacher, server, SubscriptionType.Reading, { startDate, endDate })
    },
  }),

  mathsSubco: trait({
    afterCreate(teacher, server) {
      server.create('subscription-coordinator', {
        teacher,
        school: teacher.school,
        product: SubscriptionType.Maths,
      })
    },
  }),

  readingSubco: trait({
    afterCreate(teacher, server) {
      server.create('subscription-coordinator', {
        teacher,
        school: teacher.school,
        product: SubscriptionType.Reading,
      })
    },
  }),

  writingSubco: trait({
    afterCreate(teacher, server) {
      server.create('subscription-coordinator', {
        teacher,
        school: teacher.school,
        product: SubscriptionType.Writing,
      })
    },
  }),
})
